import React from 'react';

const WhyHowWhatSection: React.FC = () => {
  const cards = [
    {
      title: 'Why?',
      mainPoints: [
        {
          title: 'Pitch fatigue into funding velocity',
          description: 'Win Credibility, before you pitch'
        },
        {
          title: 'Alignment with investors',
          description: 'Know where you stand. No guesswork, just data.'
        },
        {
          title: 'Unlock Smart Funding Matches',
          description: 'Meet the one who is looking out for you.'
        }
      ]
    },
    {
      title: 'How?',
      mainPoints: [
        {
          title: 'Automated & 100% Investor Grade',
          description: 'Tell us about your startups'
        },
        {
          title: 'Seven Dimensional Score',
          description: 'Quick and structured inputs.'
        },
        {
          title: 'Get your score and report',
          description: 'Actionable insights, boost your funding chances.'
        }
      ]
    },
    {
      title: 'What?',
      mainPoints: [
        {
          title: 'Outcome, Not Opinion',
          description: 'Score and Investor grade insights'
        },
        {
          title: 'Right Investor Matching and Meeting',
          description: 'Get connected to the relevant investor.'
        },
        {
          title: 'Competition Context',
          description: 'Benchmark yourself against others in your space.'
        }
      ]
    }
  ];

  return (
    <section className="why-how-what-section">
      <div className="cards-container">
        {cards.map((card, index) => (
          <div key={index} className="info-card" style={{ background: 'linear-gradient(0deg, rgb(255, 255, 255), rgb(255 157 133 / 14%))', borderWidth: '1px', borderColor: '#FF9E85' }}>
            <h2>{card.title}</h2>
            <div className="points-container">
              {card.mainPoints.map((point, pointIndex) => (
                <div key={pointIndex} className="point-item">
                  <h3>{point.title}</h3>
                  <p>{point.description}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyHowWhatSection;
